export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'anatomy',
    name: '前列腺生理基础',
    description: '深入了解前列腺的解剖结构、生理功能及其在男性性反应中的核心作用，为科学认识前列腺高潮奠定理论基础。',
    icon: 'ri-brain-line',
    articleCount: 4,
  },
  {
    slug: 'techniques',
    name: '刺激方法与技巧',
    description: '系统介绍前列腺刺激的多种方式与操作技巧，从入门到进阶，帮助读者安全、有效地探索前列腺高潮体验。',
    icon: 'ri-guide-line',
    articleCount: 5,
  },
  {
    slug: 'health-benefits',
    name: '健康益处与研究',
    description: '梳理科学研究成果，揭示前列腺规律性刺激对男性泌尿生殖系统健康的积极影响及潜在治疗价值。',
    icon: 'ri-heart-pulse-line',
    articleCount: 4,
  },
  {
    slug: 'safety',
    name: '安全须知与禁忌',
    description: '详细说明前列腺刺激的安全操作规范、禁忌症与风险预警，确保读者在充分了解安全信息的前提下进行实践。',
    icon: 'ri-shield-check-line',
    articleCount: 3,
  },
  {
    slug: 'faq',
    name: '常见问题解答',
    description: '收集并解答关于前列腺高潮最常见的疑问，消除误解与顾虑，提供基于医学证据的专业回复。',
    icon: 'ri-question-answer-line',
    articleCount: 4,
  },
];